import TopCollections from "components/topCollections";
import TrendingNFTs from "components/trendingNFTs";
import { HeroSection } from "../components";

const Home = () => {
  return (
    <>
      <HeroSection />
      <TopCollections />
      <TrendingNFTs />
    </>
  );
};

export default Home;
